/**
 * The CheckOne mark: FormOne's scroll-shaped "1" with a mint tile and check (brand option A, 19 Oct 2026).
 * Inline so it needs no asset request. The outline and curl follow --logo-line / --logo-curl, which the
 * stylesheet switches for the dark scheme. Decorative: the link around it carries the name.
 */
export function LogoMark({ size = 28 }: { size?: number }) {
  const line = { stroke: "var(--logo-line, #0A2540)" };
  return (
    <svg
      className="logo-mark"
      width={size}
      height={size}
      viewBox="0 0 120 120"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M4 30 V20 a11 11 0 0 1 22 0 V30 Z"
        style={{ ...line, fill: "var(--logo-curl, #C5CDD6)" }}
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <path
        d="M15 9 H80 a12 12 0 0 1 12 12 V54 H56 V104 a10 10 0 0 1 -10 10 H36 a10 10 0 0 1 -10 -10 V20 a11 11 0 0 0 -11 -11 Z"
        fill="#ffffff"
        style={line}
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <path d="M60 26 l9 -7 h6 v26 h-8 v-15 l-5 4 z" fill="#0A2540" />
      <path d="M50 54 H112 V102 a12 12 0 0 1 -12 12 H50 Z" fill="#00B884" />
      <path
        d="M63 85 l11 11 l31 -42"
        fill="none"
        stroke="#ffffff"
        strokeWidth="9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
